import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {UserService} from "./shared/services/api_v1/user.service";
import {MessageService} from "./shared/services/message.service";
import {SpinnerService} from "./shared/services/spinner.service";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {HomeModule} from "./front/home/home.module";
import {AppRoutingModule} from "./app-routing.module";
import {PageNotFoundComponent} from "./errors/page-not-found.component";
import {UploadModule} from "./front/upload/upload.module";
import {IsAdminGuard} from "./shared/services/is-admin-guard.service";
import {FirmwareService} from "./shared/services/api_v1/firmware.service";
import {NotificationComponent} from "./front/core/notifications/notifications.component";

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        RouterModule,
        FormsModule,
        HttpModule,

        HomeModule,
        UploadModule,

        AppRoutingModule
    ],
    providers: [
        UserService,
        MessageService,
        SpinnerService,
        FirmwareService,

        IsAdminGuard
    ],
    declarations: [
        AppComponent,
        NotificationComponent,

        PageNotFoundComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts